import script from "./VisionMerchant.vue?vue&type=script&setup=true&lang=ts"
export * from "./VisionMerchant.vue?vue&type=script&setup=true&lang=ts"

import "./VisionMerchant.vue?vue&type=style&index=0&id=eb484a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb484a46"]])

export default __exports__